import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';
import { environment } from 'src/environments/environment';
import { OrdenNoProgramadaRepository } from 'src/app/domain/service/orientaciones-no-programadas/orden-no-programada-repository';
import { validarSize } from 'src/app/common/validation-utils';
import {
  FiltrosOrdenNoProgramada,
  OrdenNoProgramadaPage
} from 'src/app/domain/model/orientaciones-no-programadas/orden-servicio-detalle';

/**
 * Adaptador HTTP: HttpOrdenNoProgramadaRepository
 *
 * Implementa el puerto OrdenNoProgramadaRepository para comunicación HTTP con agenda-ms.
 * Realiza llamadas REST al backend Spring Boot (OrdenNoProgramadaController).
 *
 * Arquitectura Hexagonal:
 * - Este adaptador está en infraestructura
 * - Implementa el puerto OrdenNoProgramadaRepository del dominio
 *
 * Backend: 580-girop_agenda-ms (puerto 8081)
 * Endpoint: POST /api/servicios/orientaciones-no-programadas/buscar
 *
 * @legacy pck_psc_programar_ordenes.sp_psc_consultar_ordenes
 * @author Sura - Migración GWT a Angular
 */
@Injectable({ providedIn: 'root' })
export class HttpOrdenNoProgramadaRepository extends OrdenNoProgramadaRepository {

  private readonly http = inject(HttpClient);
  private readonly baseUrl = `${environment.backend.baseUrl}/servicios/orientaciones-no-programadas/buscar`;

  override async buscarOrdenes(
    filtros: FiltrosOrdenNoProgramada,
    cursor: string | null,
    size: number,
    direction: 'NEXT' | 'PREVIOUS'
  ): Promise<OrdenNoProgramadaPage> {
    validarSize(size);
    return firstValueFrom(
      this.http.post<OrdenNoProgramadaPage>(this.baseUrl, {
        nmconsecutivoManualOrden: filtros.nmconsecutivoManualOrden || null,
        // Backend (BuscarOrientacionesRequest) espera el NMCONSECUTIVO de TPSC_EMPLEADOS, no el cdpersona.
        nmconsecutivoAsesor: filtros.nmconsecutivoAsesor || null,
        cdpersonaCliente: filtros.cdpersonaCliente || null,
        nmconsecutivoBeneficiario: filtros.nmconsecutivoBeneficiario || null,
        nmconsecutivoOficina: filtros.nmconsecutivoOficina || null,
        cdunidadAdministrativa: filtros.cdunidadAdministrativa || null,
        nmconsecHomologacionServicio: filtros.nmconsecHomologacionServicio || null,
        nmconsecBenefCt: filtros.nmconsecBenefCt || null,
        tipoFecha: filtros.tipoFecha || 'ENTREGA',
        fechaInicial: filtros.fechaInicial || null,
        fechaFinal: filtros.fechaFinal || null,
        // Backend filtra Aseguradora contra encab.NMCONSECUTIVO_CLIENTE (TPSC_CLIENTES).
        nmconsecutivoCliente: filtros.nmconsecutivoCliente || null,
        cursor,
        size,
        direction
      })
    );
  }
}
